import { useTranslation } from '@lib/useTypedTranslation';
import { SmartBatteryAlertStatus } from "../../services/config/alertConstants";
import { useLanguageAndLocaleContext } from '../../context/languageAndLocale';
import { Link } from 'react-router-dom';
import { useWorldRoutes } from '../../routes/parts/allWorldRoutes';
import './style.css';
import { ReactElement } from 'react';

export interface SortedAlert {
  name: SmartBatteryAlertStatus,
  red: number,
  yellow: number,
  sum: number,
  text: ReactElement | string
}

interface IProps {
  alerts: SortedAlert[]
}

export const AlertsTable = (props: IProps) => {
  const ns = 'alertOverview';
  const { t } = useTranslation([ns]);
  const { locale } = useLanguageAndLocaleContext();
  const basePath = useWorldRoutes().batteryEssentials.battery;

  if (props.alerts.length === 0) {
    return <>
      <div className="no_alerts__title">{t('TITLE', { alertCount: props.alerts.length, ns })}</div>
      <div className="alerts__status--no-alerts">{t('NO_ALERTS', { ns })}</div>
    </>;
  }

  const renderLinkedValue = (value: number, alertName: SmartBatteryAlertStatus, level: 'red' | 'yellow') => {
    const formattedValue = value.toLocaleString(locale);
    if (value > 0) {
      return <Link to={`${basePath}?alertStatus=${alertName}-${level}`} className="alerts__link">{formattedValue}</Link>;
    }
    return formattedValue;
  };

  return (
    <table className="alerts-table">
      <thead>
        <tr>
          <th className="alerts__title" data-id="battery-overview-alerts__title">{t('TITLE', { alertCount: props.alerts.length, ns })}</th>
          <th className="alerts__alert-icon-red"><i className={`fa fa-times-circle circle_red`} data-id="red-alert-icon" /></th>
          <th className="alerts__alert-icon-yellow"><i className={`fa fa-exclamation-triangle circle_orange enhanced-warning-icon`} data-id="yellow-alert-icon" /></th>
        </tr>
      </thead>
      <tbody className="alerts__body">
        {props.alerts.map((alert) => {
          return (
            <tr key={`alerts__body--${alert.name}`} className={`alerts__body--${alert.name}`}>
              <td>{alert.text}</td>
              <td>{renderLinkedValue(alert.red, alert.name, 'red')}</td>
              <td>{renderLinkedValue(alert.yellow, alert.name, 'yellow')}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
